var _path, _ellipse, _circle, _circle2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPercentTagYor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0006 1.37087C11.5632 0.80826 12.3263 0.492188 13.1219 0.492188H32.8793C34.5361 0.492188 35.8793 1.83533 35.8793 3.49219V21.4922C35.8793 23.149 34.5361 24.4922 32.8793 24.4922H13.2137C12.3642 24.4922 11.5545 24.132 10.9857 23.5011L2.40768 13.9873C1.33852 12.8015 1.38544 10.9861 2.51442 9.85707L11.0006 1.37087Z",
    fill: "#A7CE6A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99242,
    cy: 12.0381,
    rx: 2.45214,
    ry: 2.45214,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8499,
    cy: 7.52567,
    r: 1.91043,
    stroke: "white",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.8958,
    cy: 16.0061,
    r: 1.91043,
    stroke: "white",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.3027,
    y: 5.88891,
    width: 0.886811,
    height: 13.4056,
    rx: 0.443406,
    transform: "rotate(30 27.3027 5.88891)",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.886811
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentTagYor);
export default __webpack_public_path__ + "static/media/percentTagYor.6728a48584ee6797bc2939de2b891b7c.svg";
export { ForwardRef as ReactComponent };